import {
  isNotUndefined_default
} from "./chunk-ZNK2UXVC.mjs";

// src/monet-utils/verifyMaybe.ts
import { Maybe, None } from "monet";
import { match, when } from "ts-pattern";
function verifyMaybe(x) {
  return match(x).with({ map: when(isNotUndefined_default) }, (_val) => _val).with({ "@@type": "monet.js/Maybe" }, (_val) => Maybe.fromNull(_val.val)).otherwise((__) => None());
}
var verifyMaybe_default = verifyMaybe;

export {
  verifyMaybe_default
};
//# sourceMappingURL=chunk-M5FJK2RG.mjs.map